export default "__VITE_ASSET__BO$5gk8N__"